import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import ConsumerAuthGuard from './guards/ConsumerAuthGuard'
import ConsumerLayout from './components/layout/ConsumerLayout'

// Pages — lazy loaded for code splitting
const SigninPage = lazy(() => import('./pages/auth/SigninPage'))
const DashboardPage = lazy(() => import('./pages/dashboard/DashboardPage'))
const ContextOverview = lazy(() => import('./pages/identity/context/ContextOverview'))
const PeoplePage = lazy(() => import('./pages/identity/context/PeoplePage'))
const LifeContextPage = lazy(() => import('./pages/identity/context/LifeContextPage'))
const ProjectsPage = lazy(() => import('./pages/identity/context/ProjectsPage'))
const PersonalNotesPage = lazy(() => import('./pages/identity/context/PersonalNotesPage'))
const RecentTopicsPage = lazy(() => import('./pages/identity/context/RecentTopicsPage'))
const BootstrapSettingsPage = lazy(() => import('./pages/identity/context/BootstrapSettingsPage'))
const ProfileSettingsPage = lazy(() => import('./pages/identity/context/ProfileSettingsPage'))

function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="w-6 h-6 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Public auth route */}
          <Route path="/auth/signin" element={<SigninPage />} />

          {/* Protected consumer routes */}
          <Route element={<ConsumerAuthGuard />}>
            <Route element={<ConsumerLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/identity/context/overview" element={<ContextOverview />} />
              <Route path="/identity/context/people" element={<PeoplePage />} />
              <Route path="/identity/context/life" element={<LifeContextPage />} />
              <Route path="/identity/context/projects" element={<ProjectsPage />} />
              <Route path="/identity/context/notes" element={<PersonalNotesPage />} />
              <Route path="/identity/context/topics" element={<RecentTopicsPage />} />
              <Route path="/identity/context/settings" element={<BootstrapSettingsPage />} />
              <Route path="/identity/context/profile" element={<ProfileSettingsPage />} />
            </Route>
          </Route>

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
